<template>
  <div class="card-form container" v-if="dataFetched">
    <b-row class="mb-5 w-100 d-flex justify-content-around" :style="cardStyle">
      <img alt="Logo" :src="emissor.logo" class="max-h-80px" />
      <div class="mt-5" style="float: right; text-align: right">
        <span>{{ emissor.nome }} - {{ emissor.telefone }}</span> <br />
        <span v-if="emissor.cnpj_cpf.length < 14"
          >CPF: {{ formatCpfCnpj(emissor.cnpj_cpf) }}</span
        >
        <span v-if="emissor.cnpj_cpf.length >= 14"
          >CNPJ: {{ formatCpfCnpj(emissor.cnpj_cpf) }}</span
        >
        <br />
        <span>{{
          `${emissor.logradouro} - ${emissor.numero} - ${emissor.bairro}, ${emissor.cep}`
        }}</span
        ><br />
        <span>{{ `${emissor.cidade} - ${emissor.uf}` }}</span>
        <br />
      </div>
    </b-row>

    <strong>Pedido: </strong><span> {{ numero }} </span>
    <div>
      <div>
        <b-card
          title="Cliente"
          tag="article"
          class="my-2 border border-primary"
          :style="cardStyle"
        >
          <b-card-text>
            <strong>Nome: </strong>{{ cliente.nome }}<br />
            <strong
              v-if="cliente.cnpj_cpf !== null && cliente.cnpj_cpf.length < 14"
              >CPF: {{ formatCpfCnpj(cliente.cnpj_cpf) }} <br />
            </strong>
            <strong
              v-if="cliente.cnpj_cpf !== null && cliente.cnpj_cpf.length >= 14"
              >CNPJ: {{ formatCpfCnpj(cliente.cnpj_cpf) }}<br
            /></strong>

            <strong v-if="cliente.telefone">Telefone:</strong
            >{{ cliente.telefone }}<br />
            <div style="white-space: normal" v-if="cliente.cep">
              <strong>Endereço: </strong>
              {{ cliente.logradouro }}, {{ cliente.numero }},{{
                cliente.bairro
              }},{{ cliente.complemento }} {{ cliente.cep }},{{
                cliente.cidade
              }}-{{ cliente.uf }}
            </div>
          </b-card-text>
        </b-card>

        <b-card
          title="Produtos"
          tag="article"
          class="mb-2 border border-primary"
        >
          <b-card-text>
            <b-table
              v-if="produtos.length > 0"
              striped
              small
              hover
              :items="tableItems"
            >
              <template #row-details="row">
                <b-row
                  v-if="getProdutoObservacao(row)"
                  style="white-space: pre-line"
                >
                  <b-col>Observacao: {{ getProdutoObservacao(row) }} </b-col>
                </b-row>
              </template>
            </b-table>
          </b-card-text>
        </b-card>
        <b-card
          title="Pagamentos"
          tag="article"
          class="mb-2 border border-primary"
          :style="cardStyle"
        >
          <b-card-text
            v-for="(pagamento, index) in pagamentos"
            :key="pagamento.descricao"
          >
            <label>{{ pagamento.paymentMode.name }}</label>
            <b-table
              v-if="produtos.length > 0"
              striped
              small
              fixed
              hover
              :items="tablePagamentoItems(index)"
            />
          </b-card-text>
        </b-card>

        <b-card
          title="Outras informaçoes"
          tag="article"
          class="my-2 border border-primary"
          :style="cardStyle"
        >
          <b-card-text>
            <strong>Vendedor: </strong> {{ vendedor }} <br />
            <strong>Solicitante: </strong> {{ solicitante }} <br />
            <strong>Observação: </strong> {{ observacao }} <br />
            <strong>Dt. Validade: </strong>
            {{ validade | moment("DD/MM/YYYY") }}<br />
            <strong>Dt. Solicitação: </strong>
            {{ data_solicitacao | moment("DD/MM/YYYY") }}
            <br />
            <strong>Desconto Geral R$: </strong>
            {{ numberToReal(desconto, 2) }} <br />
            <strong>Outras despesas R$: </strong>
            {{ numberToReal(despesas, 2) }}
            <br />
            <strong>Total pedido R$: </strong> {{ numberToReal(valorTotal, 2) }}
          </b-card-text>
        </b-card>

        <span
          slot="status"
          v-if="
            status != 1 &&
            status != 7 &&
            status != 2 &&
            status != 6 &&
            status != 9 &&
            status != 10
          "
          :class="statusClass(status)"
        >
          {{ statusLabel(status) }}, por {{ contatoResposta }} :
          {{ dataResposta | moment("DD/MM/YYYY HH:mm:ss") }}
        </span>
      </div>
    </div>
    <div class="mt-5 w-100 d-flex justify-content-end">
      <img
        alt="Logo"
        :src="layoutConfig('self.logo.secundary')"
        class="max-h-60px mr-5"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import { mask } from "vue-the-mask";
import moment from "moment";

export default {
  name: "app-link-pedido",
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin],
  directives: {
    mask,
    "number-only": {
      bind(el) {
        function checkValue(event) {
          event.target.value = event.target.value.replace(/[^0-9]/g, "");
          if (event.charCode >= 48 && event.charCode <= 57) {
            return true;
          }
          event.preventDefault();
        }
        el.addEventListener("keypress", checkValue);
      },
    },
    "letter-only": {
      bind(el) {
        function checkValue(event) {
          if (event.charCode >= 48 && event.charCode <= 57) {
            event.preventDefault();
          }
          return true;
        }
        el.addEventListener("keypress", checkValue);
      },
    },
  },
  data() {
    return {
      uuid: null,
      allStatus: [],
      dataFetched: false,
      cliente: null,
      emissor: null,
      validade: null,
      observacao: null,
      pagamentos: [],
      produtos: null,
      status: null,
      valorTotal: null,
      numero: null,
      desonto: null,
      despesas: null,
      statusClient: null,
      observacaoCliente: null,
      contato: null,
      finished: false,
      contatoResposta: null,
      windowWidth: window.innerWidth,
      dataResposta: null,
      solicitante: null,
      vendedor: null,
      data_solicitacao: null,
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["pageTitle", "layoutConfig"]),
    tableItems() {
      return this.produtos.map((produto) => ({
        codigo: produto.product?.codigo,
        nome: produto.product.descricao,
        quantidade: produto.quantity,
        preco: this.numberToReal(produto.price, 2),
        desconto: this.numberToReal(produto.discount, 2),
        total: this.numberToReal(produto.totalPrice, 2),
        _showDetails: true,
      }));
    },
    produtoObservacoes() {
      return this.produtos.map((produto) => produto?.product?.obs);
    },
    isMobile() {
      return this.windowWidth < 569;
    },
    cardStyle() {
      return {
        width: this.isMobile ? "94vw" : "",
      };
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    getProdutoObservacao(row) {
      const index = row.index;
      const produto = this.produtos?.[index];
      return produto?.product?.obs || null;
    },
    tablePagamentoItems(index) {
      return this.pagamentos[index].range.map((parcela, index) => ({
        parcela: index + 1,
        "Valor R$": this.numberToReal(parcela.value, 2),
        vencimento: moment(parcela.date).format("DD/MM/YYYY"),
      }));
    },
  },
  async mounted() {
    const { uuid } = this.$route.params;
    this.setLoading(true);
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    this.$http
      .post("/pedido/busca-pedido", {
        uuid,
      })
      .then(({ data }) => {
        this.cliente = data.cliente;
        this.emissor = data.emissor;
        this.validade = data.dataValidade;
        this.data_solicitacao = data.data_solicitacao;
        this.observacao = data.observacao;
        this.pagamentos = data.pagamentos;
        this.produtos = data.produtos;
        this.status = data.status;
        this.valorTotal = data.valorTotal;
        this.numero = data.numero;
        this.desconto = data.desconto;
        this.despesas = data.outrasDespesas;
        this.vendedor = data.vendedor?.nome ?? null;
        this.solicitante = data.solicitante ?? null;
        if (data.contato) {
          this.contatoResposta = data.contato;
        }
        if (data.dataAlteracao) {
          this.dataResposta = data.dataAlteracao;
        }
        this.dataFetched = true;
        this.setLoading(false);
      })
      .catch((error) => {
        this.setLoading(false);
        this.$toast.error(`Erro ao buscar pedido:\n${error}`);
      });
    await this.getInit();
  },
  created() {},
};
</script>
<style scoped>
svg {
  outline-width: 0;
  outline-color: transparent;
  color: rgb(241, 249, 255);
}

.container {
  background-color: white;
  border-radius: 10px;
  padding: 1rem;
  box-shadow: 0px 0px 30px 0px rgba(82, 63, 105, 0.05);
}

.select-city .vs__search::placeholder,
.select-city .vs__dropdown-toggle,
.select-city .vs__dropdown-menu {
  height: 10rem !important;
  /* width:  100%; */
  background-color: green !important;
}

.contato-input {
  height: 3rem;
}
</style>